/* eslint-disable no-unused-vars */
/*
DateFormating mixins
------------------------------------------------------------------------ */
import moment from 'moment'

import {settings, DATE_SQL_FORMAT, DATETIME_SQL_FORMAT} from '@/components/Data'

export default {
  methods: {

    now (fmt) {
      if (fmt && typeof fmt === 'string') {
        return moment().format(fmt)
      } else {
        return moment()
      }
    },



    today () {
      return moment(new Date(), 'YYYY-MM-DD')
    },



    year (date = null) {
      if (date) {
        return moment(date).year()
      } else {
        return moment().year()
      }
    },



    fromToday (value, todaysDate = null) {
      if (value === null) {
        return NaN
      } else {

        if (!todaysDate) {
          todaysDate = moment(new Date())
        }

        var oDate = moment(value)
        return oDate.diff(todaysDate, 'days')
      }
    },



    daysDiff (d1, d2) {
      if (d1 === null || d2 === null) {
        return NaN
      } else {

        var oDate = moment(d1)
        var oDate2 = moment(d2)

        return oDate.diff(oDate2, 'days')
      }
    },



    isOverdue (value) {
      if (value == null) {
        return false
      } else {
        return isNaN(this.fromToday()) ? false : this.fromToday(value) < 0
      }
    },



    addDate (value, incr = 1, period = 'day', fmt = 'YYYY-MM-DD') {
      if (value == null) {
        return null
      } else { // , 'YYYY-MM-DD'
        return moment(value).add(Number(incr), period).format(fmt)
      }
    },



    addDateTime (value, incr = 1, period = 'day', fmt = 'YYYY-MM-DD') {
      return (value == null)
      ? null
      : moment(value, 'YYYY-MM-DD HH:mm:ss').add(Number(incr), period).format(fmt)
    },



    subDate (value, incr = 1, period = 'day', fmt = 'YYYY-MM-DD') {
      return (value == null)
      ? null
      : moment(value).subtract(Number(incr), period).format(fmt)  // , 'YYYY-MM-DD'
    },



    subDateTime (value, incr = 1, period = 'day', fmt = 'YYYY-MM-DD') {
      return (value == null)
      ? null
      : moment(value, 'YYYY-MM-DD HH:mm:ss').subtract(Number(incr), period).format(fmt)
    },



    contractExpiryDate (value, incr = 1, period = 'years', fmt = 'YYYY-MM-DD') {
      var rawDate = this.addDate(value, incr, period, fmt)
      return this.subDate(rawDate, 1, 'day', fmt)
    },



    formatDate (value, fmt = settings.dateFormat) {
      return (value == null)
      ? null
      : moment(value).format(fmt) // , 'YYYY-MM-DD'
    },



    formatDateSql (value, fmt = DATE_SQL_FORMAT) {
      if (value && (typeof value === 'string')) {
        value.trim()
      }

      return (value == null || value === 'Invalid date' || value === '')
      ? null
      : moment(value).format(fmt)  //, 'YYYY-MM-DD'
    },



    formatDateTime (value, fmt = settings.dateTimeFormat) {
      return (value == null)
      ? null
      : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
    },



    formatDateTimeSql (value, fmt = DATETIME_SQL_FORMAT) {
      if (value && (typeof value === 'string')) {
        value.trim()
      }

      return (value == null)
      ? null
      : moment(value, 'YYYY-MM-DD HH:mm:ss').format(fmt)
    },



    formatFriendlyDate (value, color = false, fmt = settings.dateHumanFormat) {
      if (value && typeof value === 'string') {
        value.trim()
      }

      let d = (value == null)
      ? null
      : moment(value).fromNow()

      if (color && value) {
        if (this.isOverdue(value)) {
          d = '<span class="text-danger">' + d + '</span>'
        } else {
          d = '<span class="text-primary">' + d + '</span>'
        }
      }
      return d
    },



   arrayOfYears (wayBack) {
      let years = []

      if (Number(wayBack) > 0 && Number(wayBack) < 100) {
        wayBack = Number(wayBack)
      } else {
        wayBack = 10
      }
      let max = (new Date()).getFullYear()
      let min = (max - wayBack)

      if (years.length === 0) {
        if (years.length !== max) {
          for (let y = max; y >= min; y--) {
            years.push(y)
          }
        }
      } // if years.length === 0 ...

      return years
    }
  }

}
